<template>
  <div>
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title>
        Post Reports
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <div class="ma-4" id="user-list">
      <v-simple-table>
        <thead>
          <tr>
            <th width="1%"></th>
            <th width="20%" class="text-left">Posted by</th>
            <th width="40%" class="text-left">Post Content</th>
            <th width="10%" class="text-left">Reported by</th>
            <th class="text-left">Posted on</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <template v-if="reportedPosts.data.length">
            <tr v-for="post in reportedPosts.data" :key="post.id">
              <td>
                <v-avatar class="ma-2" color="grey lighten-2" size="38">
                  <img :src="post.user.avatar_thumb_url" alt="avatar" />
                </v-avatar>
              </td>
              <td>
                {{ post.user.full_name }}
              </td>
              <td class="py-4">
                <v-img
                  v-if="post.image"
                  :aspect-ratio="4 / 3"
                  :src="post.image.url"
                  :lazy-src="post.image.thumb_url"
                />
                <div class="mt-4 content quill" v-html="post.post"></div>
              </td>
              <td>
                {{ post.count_unique_reporters }}
                {{ post.count_unique_reporters > 1 ? 'students' : 'student' }}
              </td>
              <td>{{ post.createdAt }}</td>
              <td class="text-right">
                <v-menu>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="viewReports(post)">
                      <v-list-item-title>View reports</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="deletePost(post)">
                      <v-list-item-title>Delete post</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
          <tr v-else>
            <td class="text-center headline grey--text py-10" colspan="6">
              No reports available.
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-overlay absolute :value="loading" opacity="0.1">
        <v-progress-circular indeterminate color="primary" size="64" />
      </v-overlay>
    </div>
    <div v-if="reportedPosts.meta.last_page > 1" class="text-center mt-4">
      <v-pagination
        @input="pageChanged"
        :value="reports.meta.current_page"
        :length="reports.meta.last_page"
        :total-visible="10"
        circle
      />
    </div>

    <reports-dialog :post="selectedPost" v-model="showReportsDialog" />
  </div>
</template>

<script>
import { mdiDotsVertical } from '@mdi/js'
import ReportPost from '@/models/ReportPost'
import Post from '@/models/Post'
import ReportsDialog from './Reports'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'

export default {
  name: 'ReportsPage',
  components: {
    ReportsDialog,
    AppBarNavIcon
  },
  data() {
    return {
      loading: false,
      icons: {
        settings: mdiDotsVertical
      },
      showReportsDialog: false,
      selectedPost: null,
      reportedPosts: {
        data: [],
        meta: {
          current_page: 1
        }
      }
    }
  },

  methods: {
    pageChanged(page) {
      this.reportedPosts.meta.current_page = page
      this.getReports()
    },

    getReports() {
      this.loading = true
      return ReportPost.include('user', 'image')
        .orderBy('latest-report')
        .limit(15)
        .page(this.reportedPosts.meta.current_page)
        .get()
        .then(response => {
          this.reportedPosts = response
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },

    viewReports(post) {
      this.selectedPost = new Post(post)
      this.showReportsDialog = true
    },

    deletePost(reportedPost) {
      this.$confirm(`Are you sure you want to remove this post?`, {
        color: 'primary',
        title: 'Remove post'
      }).then(confirm => {
        if (confirm) {
          const post = new Post(reportedPost)
          post
            .delete()
            .then(() => {
              this.reportedPosts.meta.current_page = 1
              return this.getReports()
            })
            .then(() => {
              this.$toast('Post has been successfully removed!', {
                color: 'green'
              })
            })
        }
      })
    }
  },

  created() {
    this.getReports()
  }
}
</script>
